/**
 * DATORACODE - Shop the Look Slider (PDP)
 *
 * Post-processes content loaded by Dawn's product-recommendations custom element,
 * initializes Flickity carousel, handles color-swap on Dawn PubSub variantChange,
 * and opens upsell modal on ATC click.
 */
(function () {
  'use strict';

  // ─── 1. Observe product-recommendations containers for content injection ──
  function init() {
    var containers = document.querySelectorAll('product-recommendations.shop-the-look-slider');
    if (!containers.length) return;

    containers.forEach(function (el) {
      if (el.querySelector('.stl-slider__carousel')) {
        onContentLoaded(el);
        return;
      }

      var observer = new MutationObserver(function () {
        if (el.querySelector('.stl-slider__carousel')) {
          observer.disconnect();
          onContentLoaded(el);
        }
      });
      observer.observe(el, { childList: true, subtree: true });
    });

    // DATORACODE - Subscribe once globally, not per onContentLoaded call
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var color = event.data && event.data.variant ? event.data.variant.option1 : null;
      containers.forEach(function (el) {
        updateAllCards(el, color);
      });
    });

    // DATORACODE - Re-run CO2 discount on cart update (code added/removed)
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      containers.forEach(function (el) {
        refreshSliderDiscounts(el);
      });
    });
  }

  // ─── 2. Content loaded: init carousel + color swap ─────────────────────────
  function onContentLoaded(container) {
    var headingEl = container.querySelector('[data-stl-heading]');
    var headingText = container.getAttribute('data-heading');
    if (headingEl && headingText) {
      headingEl.textContent = headingText;
    }

    updateAllCards(container, getCurrentColor());
    initFlickity(container);
  }

  // ─── 3. Read current PDP color (initial load only) ────────────────────────
  function getCurrentColor() {
    var el = document.querySelector('variant-selects [data-selected-variant]');
    if (el) {
      try {
        return JSON.parse(el.innerHTML).option1;
      } catch (e) {}
    }
    return null;
  }

  // ─── 4. Color Taxonomy Maps ────────────────────────────────────────────────
  var byName = {};   // Farbname → Taxonomy-Ref
  var byTaxonomy = {}; // Taxonomy-Ref → [Farbname, Farbname, ...]

  function initColorTaxonomy(container) {
    if (Object.keys(byName).length) return;
    try {
      byName = JSON.parse(container.getAttribute('data-color-taxonomy'));
    } catch (e) {
      byName = {};
    }
    Object.keys(byName).forEach(function (name) {
      var tax = byName[name];
      if (!byTaxonomy[tax]) byTaxonomy[tax] = [];
      byTaxonomy[tax].push(name);
    });
  }

  // ─── 4a. Handleize (CFSN-503): pragmatic JS approximation of Shopify's handleize
  function handleizeJs(s) {
    return String(s)
      .toLowerCase()
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 'ss')
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // ─── 4. Dreistufiger Color-Lookup ──────────────────────────────────────────
  function findColorEntry(colorMap, color) {
    if (!color) return colorMap['default'];

    // 1. Exakter Match
    if (colorMap[color]) return colorMap[color];

    // 2. Taxonomy-Fallback: Synonyme suchen (Label oder Handle als Key — CFSN-503)
    var tax = byName[color] || byName[handleizeJs(color)];
    if (tax && byTaxonomy[tax]) {
      for (var i = 0; i < byTaxonomy[tax].length; i++) {
        if (colorMap[byTaxonomy[tax][i]]) return colorMap[byTaxonomy[tax][i]];
      }
    }

    // 3. Default
    return colorMap['default'];
  }

  // ─── 5. Update all cards to match current color ───────────────────────────
  function updateAllCards(container, color) {
    initColorTaxonomy(container);
    var cards = container.querySelectorAll('.stl-card');

    cards.forEach(function (card) {
      var colorMap;
      try {
        colorMap = JSON.parse(card.getAttribute('data-color-map'));
      } catch (e) {
        return;
      }

      var entry = findColorEntry(colorMap, color);
      if (!entry) return;

      var img = card.querySelector('.stl-card__image');
      if (img) {
        img.src = entry.image_url;
      }

      var atcBtn = card.querySelector('.stl-card__atc');
      if (atcBtn) {
        atcBtn.setAttribute('data-product-url', entry.product_url + '?variant=' + entry.variant_id);
        atcBtn.setAttribute('data-variant-id', entry.variant_id);
      }

      var link = card.querySelector('.stl-card__link');
      if (link) {
        link.href = entry.product_url + '?variant=' + entry.variant_id;
      }

      var titleLink = card.querySelector('.stl-card__title-link');
      if (titleLink) {
        titleLink.href = entry.product_url + '?variant=' + entry.variant_id;
      }

      if (entry.product_id) {
        card.setAttribute('data-datora-product-id', entry.product_id);
      }
      if (entry.variant_id) {
        card.setAttribute('data-datora-variant-id', entry.variant_id);
      }
      if (entry.tags) {
        card.setAttribute('data-datora-tags', entry.tags);
      }
      card.setAttribute('data-datora-price', entry.price);
      card.setAttribute('data-datora-sale-price', entry.sale_price);
      card.setAttribute('data-datora-compare', entry.compare || 0);

      updateCardPrice(card, entry);
    });

    if (typeof window.datoraUpdatePrices === 'function') {
      window.datoraUpdatePrices(container);
    }
  }

  // ─── 4b. Update price elements on a card ──────────────────────────────────
  function updateCardPrice(card, entry) {
    var priceEl = card.querySelector('.stl-card__price');
    var compareEl = card.querySelector('.stl-card__compare-price');
    var badgeEl = card.querySelector('.stl-card__badge-sale');

    if (!priceEl) return;

    var displayPrice = entry.price;
    var comparePrice = entry.compare || 0;
    var hasSale = entry.sale_price === true && comparePrice > displayPrice;
    // DATORACODE - Compare/Badge-UI an hide_compare_prices koppeln, data-datora-* bleibt real
    var hideComparePrices = !!(window.themeSettings && window.themeSettings.hideComparePrices);
    var showSaleUi = hasSale && !hideComparePrices;

    // DATORACODE - Basis-Preise setzen (vor Discount) — setPriceText, weil moneyFormat HTML enthalten kann (transcy-money)
    setPriceText(priceEl, formatPrice(displayPrice));

    if (compareEl) {
      if (showSaleUi) {
        setPriceText(compareEl, formatPrice(comparePrice));
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    // DATORACODE - Badge nur über CO2-Discount, nicht über hasSale
    if (badgeEl) {
      badgeEl.textContent = '';
      badgeEl.style.visibility = 'hidden';
    }

    // DATORACODE - Discount-Berechnung über co2 (gleiche Logik wie datora.js)
    function runCo2Discount() {
      co2.getDiscountCode().then(function (discountCode) {
        if (!discountCode) return;

        var pid = Number(card.getAttribute('data-datora-product-id'));
        var vid = Number(card.getAttribute('data-datora-variant-id'));
        var tags = card.getAttribute('data-datora-tags');
        var tagsArr = tags ? tags.split(',') : [];
        var onSale = card.getAttribute('data-datora-sale-price') === 'true';

        co2.itemDiscountFull(pid, vid, tagsArr, Number(displayPrice), 1, false, onSale).then(function (data) {
          if (!data) return;

          var validDisc = false;
          var newPrice, badgeText;

          if (data.calc === 'perc' && data.discPerc > 0) {
            validDisc = true;
            newPrice = formatPrice(data.discPrice);
            badgeText = '<b>-' + data.discPerc + '%</b>';
          } else if (data.calc === 'amt' && data.discAmt > 0) {
            validDisc = true;
            newPrice = formatPrice(data.discPrice);
            badgeText = '<b>-' + formatPrice(displayPrice - data.discPrice) + '</b>';
          }

          if (validDisc) {
            setPriceText(priceEl, newPrice);
            if (compareEl) {
              setPriceText(compareEl, formatPrice(displayPrice));
              compareEl.style.display = '';
            }
            if (badgeEl) {
              badgeEl.innerHTML = badgeText;
              badgeEl.style.visibility = '';
            }
          }
        });
      });
    }

    // CO2 kann noch nicht initialisiert sein wenn der Slider lädt
    if (typeof co2 !== 'undefined' && typeof co2.getDiscountCode === 'function') {
      runCo2Discount();
    } else {
      window.addEventListener('co2.cart.initialized', function () {
        runCo2Discount();
      });
    }
  }

  // ─── 4c. Refresh slider discounts (on cart update) ─────────────────────────
  function refreshSliderDiscounts(container) {
    var cards = container.querySelectorAll('.stl-card');
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.stl-card__price');
      var compareEl = card.querySelector('.stl-card__compare-price');
      var badgeEl = card.querySelector('.stl-card__badge-sale');
      var price = Number(card.getAttribute('data-datora-price'));
      var compare = Number(card.getAttribute('data-datora-compare') || 0);
      // DATORACODE - Compare/Badge-UI an hide_compare_prices koppeln, data-datora-* bleibt real
      var hideComparePrices = !!(window.themeSettings && window.themeSettings.hideComparePrices);

      // Reset to base prices — setPriceText, weil moneyFormat HTML enthalten kann (transcy-money)
      if (priceEl) setPriceText(priceEl, formatPrice(price));
      if (compareEl) {
        if (compare > price && !hideComparePrices) {
          setPriceText(compareEl, formatPrice(compare));
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }
      if (badgeEl) {
        badgeEl.textContent = '';
        badgeEl.style.visibility = 'hidden';
      }

      // Re-run CO2 discount
      if (typeof co2 !== 'undefined' && typeof co2.getDiscountCode === 'function') {
        co2.getDiscountCode().then(function (discountCode) {
          if (!discountCode) return;

          var pid = Number(card.getAttribute('data-datora-product-id'));
          var vid = Number(card.getAttribute('data-datora-variant-id'));
          var tags = card.getAttribute('data-datora-tags');
          var tagsArr = tags ? tags.split(',') : [];
          var onSale = card.getAttribute('data-datora-sale-price') === 'true';

          co2.itemDiscountFull(pid, vid, tagsArr, price, 1, false, onSale).then(function (data) {
            if (!data) return;

            var validDisc = false;
            var newPrice, badgeText;

            if (data.calc === 'perc' && data.discPerc > 0) {
              validDisc = true;
              newPrice = formatPrice(data.discPrice);
              badgeText = '<b>-' + data.discPerc + '%</b>';
            } else if (data.calc === 'amt' && data.discAmt > 0) {
              validDisc = true;
              newPrice = formatPrice(data.discPrice);
              badgeText = '<b>-' + formatPrice(price - data.discPrice) + '</b> | ' + discountCode.toUpperCase();
            }

            if (validDisc) {
              if (priceEl) setPriceText(priceEl, newPrice);
              if (compareEl) {
                setPriceText(compareEl, formatPrice(price));
                compareEl.style.display = '';
              }
              if (badgeEl) {
                badgeEl.innerHTML = badgeText;
                badgeEl.style.visibility = '';
              }
            }
          });
        });
      }
    });
  }

  // ─── 5. Initialize Flickity carousel ──────────────────────────────────────
  function initFlickity(container) {
    var carousel = container.querySelector('[data-stl-carousel]');
    if (!carousel) return;

    if (typeof Flickity !== 'undefined') {
      createFlickity(carousel, container);
    } else {
      var onLoad = function () {
        if (typeof Flickity !== 'undefined') {
          createFlickity(carousel, container);
          window.removeEventListener('load', onLoad);
        }
      };
      window.addEventListener('load', onLoad);
    }
  }

  function createFlickity(carousel, container) {
    if (carousel.flickityInstance) return;

    var stlOpts = window.getFlickityOptions(carousel, { percentPosition: true, imagesLoaded: true });
    var flkty = new Flickity(carousel, stlOpts);

    carousel.flickityInstance = flkty;
    carousel.stlContainer = container;

    var isDragging = false;

    flkty.on('dragStart', function () {
      isDragging = true;
    });

    flkty.on('dragEnd', function () {
      setTimeout(function () {
        isDragging = false;
      }, 100);
    });

    carousel.addEventListener('click', function (e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    if (typeof window.datoraUpdatePrices === 'function') {
      window.datoraUpdatePrices(container);
    }
  }

  // Re-init all carousels on viewport boundary change so step/freeScroll/
  // friction settings update without a page reload.
  if (window.SliderSettings && typeof window.SliderSettings.onBreakpointChange === 'function') {
    window.SliderSettings.onBreakpointChange(function () {
      document
        .querySelectorAll('product-recommendations.shop-the-look-slider [data-stl-carousel]')
        .forEach(function (carousel) {
          if (carousel.flickityInstance) {
            carousel.flickityInstance.destroy();
            carousel.flickityInstance = null;
          }
          createFlickity(carousel, carousel.stlContainer || carousel.closest('product-recommendations'));
        });
    });
  }

  // ─── 6. Bootstrap ─────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
